import * as React from 'react'
import { withRouter } from 'react-router-dom'
import Overlay from './Overlay'
import NotificationsView from '../PartialViews/NotificationsView'
import HeaderView from '../PartialViews/HeaderView'
import FooterView from '../PartialViews/FooterView'
import PageView from '../PartialViews/PageView'
import { observer } from 'mobx-react'
import LeftMenuView from '../PartialViews/LeftMenuView'
import ConfigStore from '../../Stores/ConfigStore'
import NotificationsStore, { NotificationEntity } from '../../Stores/NotificationsStore'
import LocalizationStore from '../../Stores/LocalizationStore'

const KeyboardEventHandler = require('react-keyboard-event-handler')

@observer
class Layout extends React.Component<any> {

  cs = ConfigStore.getInstance()

  switchMockMode = (key: any, e: any) => {
    this.cs.switchMockMode()
    const ls = LocalizationStore.getInstance()
    const ns = NotificationsStore.getInstance()
    ns.setList(
      [new NotificationEntity(
        'success', 
        ls.t(this.cs.mockMode ? 'Mocked data mode enabled' : 'Mocked data mode disabled')
      )]
    )

    const { history, location } = this.props
    const current = location.pathname
    history.push('/reload')
    setTimeout(() => {
      history.replace(current)
    })
  }

  render() {
    return (
      <div className="App">
        <KeyboardEventHandler handleKeys={this.cs.mockModeKeys} onKeyEvent={this.switchMockMode} />
        <NotificationsView />
        <Overlay />
        <div className="wrapper">
          <LeftMenuView />
          <HeaderView />    
          <PageView>
            {this.props.children}
          </PageView>
        </div>
        <FooterView />
      </div>
    )
  }
}

export default withRouter(Layout)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Layout/Layout.tsx